import { DailyParticipant } from '@daily-co/daily-js';

import { SkinToneReactions } from '/features/chat/contexts/ChatProvider';
/*
 * Only for advanced chat
 * Whether a participant has given the same type of emoji reaction on
 * the message before.
 */
export const hasReactedBefore = (
  messageReactions: SkinToneReactions,
  sessionId: DailyParticipant['session_id']
): boolean => {
  return Object.values(messageReactions).some((reaction) =>
    reaction.includes(sessionId)
  );
};

/*
 * Only for advanced chat
 * Whether a message has reactions or not
 */
export const hasReactions = (message): boolean => {
  return Object.values(message.reactions ?? {}).some((o) =>
    Object.values(o).some((ids) => ids.length > 0)
  );
};
